import { t } from '@lingui/macro';

const userHelpTextStrings = () => ({
  application: t`The application that this token belongs to, or leave this field empty to create a Personal Access Token.`,
  scope: t`Scope for the token's access`,
});

export default userHelpTextStrings;
